import {isDonationTicketDefinition} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {CloseSmall, SelectFill} from '@wix/wix-ui-icons-common/on-stage'
import {Divider, IconButton} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useColors} from '../../../../../hooks/colors'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {isInMobileBasket} from '../../../../../selectors/seating/mode'
import {isPlaceInBasket, shouldShowSeatInfo} from '../../../../../selectors/seating/place'
import {WholeElementReservation} from '../whole-element-reservation'
import {CustomDatesLabel} from './custom-dates-label'
import {TicketInfoProps} from './interfaces'
import {SeatInfo} from './seat-info'
import {TicketInfoTexts} from './ticket-info-texts'
import {classes} from './ticket-info.st.css'

export const TicketInfo = ({
  place,
  showAccessibilityMode,
  inDrawer,
  onCloseClick,
  inPopover,
  basketView,
  inDescription,
  selected,
}: TicketInfoProps) => {
  const {isMobile} = useEnvironment()

  const {resetAreaCounterValue} = useAppActions()
  const mobileBasketView = useAppSelector(isInMobileBasket)

  const {darkColor} = useColors()
  const showCustomDatesLabel = inDrawer || showAccessibilityMode || inPopover
  const inBasket = isPlaceInBasket(place)
  const isDonation = place.ticket ? isDonationTicketDefinition(place.ticket) : false
  const showCheckbox = inBasket && !selected && !basketView && !inPopover && !inDescription
  const showSeatInfo = shouldShowSeatInfo(place)

  const handleTicketInfoClose = () => {
    onCloseClick()
    resetAreaCounterValue({place, keepQuantityIfNeeded: true})
  }

  return (
    <div className={classes.container}>
      {onCloseClick ? (
        <IconButton
          data-hook={DH.CLOSE_DRAWER}
          className={classes.headerButton}
          icon={<CloseSmall />}
          onClick={handleTicketInfoClose}
        />
      ) : null}
      {showCheckbox ? (
        <SelectFill
          className={classNames(classes.checkbox, {
            [classes.checkboxFillWired]: darkColor,
            [classes.checkboxFillNotWired]: !darkColor,
          })}
        />
      ) : null}
      {showCustomDatesLabel && <CustomDatesLabel place={place} />}
      <TicketInfoTexts
        forcePricingOptionRangeLabel={isMobile && !mobileBasketView && !showAccessibilityMode}
        place={place}
        inPopover={inPopover}
        inDrawer={inDrawer}
      />
      {(inPopover || inDrawer) && !isDonation ? (
        <WholeElementReservation place={place} basketView={false} inDescription={false} showAccessibilityMode={false} />
      ) : null}
      {showSeatInfo && inPopover ? (
        <>
          <Divider className={classes.divider} />
          <SeatInfo place={place} />
        </>
      ) : null}
    </div>
  )
}
